import { companyAlertsDefaults } from "./defaults";

export default companyAlertsDefaults();
